<script lang="ts">
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import HomeIcon from '@athena-lib/Icons/Home.svelte';
  import Stack from '@athena-lib/Stack/Stack.svelte';
  import StackItem from '@athena-lib/Stack/StackItem.svelte';
  import SideScrollableContent from '@athena-lib/StickerShopHeader/SideScrollableContent.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { getLocalizationContext } from '@athena-lib/i18n';
  import Breadcrumbs from '@athena-lib/Breadcrumbs/Breadcrumbs.svelte';
  import Image from '@athena-lib/Image/Image.svelte';
  import type { BlogLayoutProps } from './types';
  const { categories, logo, breadcrumbs, blogLandingSlug }: BlogLayoutProps = $props();
  const locale = getLocalizationContext();
  const todaysDate = new Date().toLocaleDateString(locale.language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  const translations = getCommonTranslations();
</script>

{#snippet Logo(size: 'small' | 'big')}
  {#if logo && logo.url}
    <Image class={size === 'small' ? 'h-16' : 'h-28'} src={logo.url} alt={logo.alt ?? ''} />
  {/if}
{/snippet}

{#snippet desktopHeader()}
  <div class="hidden min-h-28 justify-between md:flex">
    <div class="mr-7 min-w-fit content-center">{@render Logo('big')}</div>
    <div class="flex-grow overflow-hidden">
      <Stack class="h-full justify-between">
        <StackItem>
          <div class="flex w-full justify-between">
            <div class="flex flex-wrap text-lg font-semibold text-st-gray-800">
              <span>{translations.stickerAppMagazineHeader}&nbsp;•&nbsp;</span>
              <span class="overflow-hidden text-nowrap text-lg font-semibold text-st-gray-500">
                {translations.stickerAppMagazineSubHeader}
              </span>
            </div>
            <div class="flex justify-end text-lg font-semibold text-st-gray-800">
              {todaysDate}
            </div>
          </div>
        </StackItem>
        <StackItem>
          <SideScrollableContent class="h-10 text-nowrap bg-st-gray-800 font-normal text-st-white">
            <a href={blogLandingSlug} class="h-full min-w-16 content-center bg-st-red">
              <HomeIcon sizeClass="w-8 h-8 m-auto" />
            </a>
            {#each categories as cat}
              <a href={cat.url} class="content-center px-7">
                {cat.name}
              </a>
            {/each}
          </SideScrollableContent>
        </StackItem>
      </Stack>
    </div>
  </div>
{/snippet}

{#snippet mobileHeader()}
  <div class="flex flex-col justify-between gap-6 md:hidden">
    <div class="flex items-center justify-between gap-2 pr-gutter">
      {@render Logo('small')}

      <div class="flex w-full flex-col justify-between text-right">
        <span class="text-xs">{translations.stickerAppMagazineHeader}</span>
        <span class="text-sm font-semibold text-st-gray-500">
          {translations.stickerAppMagazineSubHeader}
        </span>
        <div class="flex justify-end text-xs font-semibold text-st-gray-800">
          {todaysDate}
        </div>
      </div>
    </div>
    <div class="overflow-hidden">
      <SideScrollableContent class="h-10 text-nowrap bg-st-gray-800 font-normal text-st-white">
        <a href={blogLandingSlug} class="h-full min-w-16 content-center bg-st-red">
          <HomeIcon sizeClass="w-8 h-8 m-auto" />
        </a>
        {#each categories as cat}
          <a href={cat.url} class="mx-7 content-center">
            {cat.name}
          </a>
        {/each}
      </SideScrollableContent>
    </div>
  </div>
{/snippet}

<div class="bg-st-creme">
  <PageSection
    innerClass="pl-gutter md:pr-gutter "
    class="py-4 md:py-6"
    xSpace={'none'}
    ySpace={'none'}
    backgroundColor="none"
  >
    {@render mobileHeader()}
    {@render desktopHeader()}
  </PageSection>
  {#if breadcrumbs}
    <PageSection width="large" backgroundColor="medium" ySpace="small">
      <Breadcrumbs linkClass="text-st-red" {breadcrumbs}></Breadcrumbs>
    </PageSection>
  {/if}
</div>
